<script setup lang="ts">
import AppShell from './layouts/AppShell.vue'
</script>

<template>
  <AppShell />
</template>
